import React, { useState } from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSwitchToRegister: () => void;
  onLoginSuccess: (role: 'admin' | 'user') => void;
}

export const LoginModal: React.FC<ModalProps> = ({ isOpen, onClose, onSwitchToRegister, onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleRegisterClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onSwitchToRegister();
  };
  
  const handleLoginSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (email === 'AdminMultas' && password === 'Multas345%') {
      onLoginSuccess('admin');
    } else {
      onLoginSuccess('user');
    }
  };

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      title="Bienvenido de nuevo"
      containerClassName="max-w-md"
      headerClassName="justify-center text-center"
      mainClassName="bg-gray-50"
    >
      <p className="text-center text-gray-600 -mt-4 mb-8">
        Inicia sesión para gestionar tus casos y comunicaciones.
      </p>
      <form className="space-y-6" onSubmit={handleLoginSubmit}>
        <div>
          <label htmlFor="login-email" className="sr-only">Correo Electrónico</label>
          <input
            id="login-email"
            name="email"
            type="text"
            autoComplete="email"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors"
            placeholder="Correo Electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="login-password" className="sr-only">Contraseña</label>
          <input
            id="login-password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="flex items-center justify-end">
          <div className="text-sm">
            <a href="#" className="font-medium text-blue-600 hover:underline">
              ¿Olvidaste tu contraseña?
            </a>
          </div>
        </div>
        <div>
          <Button variant="success" size="large" className="w-full group relative flex justify-center" type="submit">
             <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg className="h-5 w-5 text-green-400 group-hover:text-green-300" fill="currentColor" viewBox="0 0 20 20">
                    <path clipRule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" fillRule="evenodd"></path>
                </svg>
            </span>
            Iniciar Sesión
          </Button>
        </div>
      </form>
      <p className="mt-8 text-center text-sm text-gray-600">
        ¿No tienes una cuenta?{' '}
        <button onClick={handleRegisterClick} className="font-medium text-blue-600 hover:underline">
          Regístrate
        </button>
      </p>
    </ModalBase>
  );
};